'use client';

import { Label, Switch } from '@commenda/kakashi';

export function FormSummaryEditor({
  props,
  onUpdateProps,
}: {
  props: Record<string, unknown>;
  onUpdateProps: (key: string, value: unknown) => void;
}) {
  return (
    <div className="space-y-4">
      <h3 className="txt-small-medium text-text-secondary">Form Summary</h3>

      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-col gap-0.5">
          <Label>Show nested form data</Label>
          <p className="txt-xs-regular text-text-tertiary">
            Display entries from nested forms in the summary
          </p>
        </div>
        <Switch
          checked={(props.showNestedFormData as boolean) ?? true}
          onCheckedChange={(checked) =>
            onUpdateProps('showNestedFormData', checked)
          }
        />
      </div>
    </div>
  );
}
